const translationsLocationTimes = {
  'de-DE': {
    descriptionOrg:
      'DR SMILE gilt als Expert*in für Zahnkorrekturen mit spezialisierten und individuellen Lösungen zu fairen Preisen. Wir ermöglichen selbstbewusste Lächeln durch unsere maßgeschneiderten Zahnschienen und personalisierte Betreuung.',
    contactPoint: {
      telephone: '+49 30 22957384',
      email: 'customer@drsmile.de',
    },
    address: {
      addressCountry: 'DE',
    },
    sameAs: [
      '',
      'https://www.facebook.com/drsmile.de/',
      'https://www.instagram.com/drsmile.de/',
      'https://www.pinterest.de/drsmile_de/',
      'https://www.youtube.com/channel/UCrK0aMXoPfRKE1twYHPB36w',
      'https://www.linkedin.com/company/drsmile/',
      'https://www.xing.com/companies/drsmile',
      'https://www.tiktok.com/@drsmile_official',
      'https://www.kununu.com/de/drsmile',
    ],
  },
  'de-AT': {
    descriptionOrg:
      'Die DR SMILE Zahnschienen werden mit modernster Technologie maßgefertigt und an die spezifischen Anforderungen der Kund*innen angepasst. Wir verwirklichen selbstbewusste Lächeln durch unsere maßgeschneiderten Zahnschienen',
    contactPoint: {
      telephone: '+43 720 230 566',
      email: 'patient@drsmile.at',
    },
    address: {
      addressCountry: 'AT',
    },
    sameAs: [
      '',
      'https://www.facebook.com/drsmile.de/',
      'https://www.instagram.com/drsmile.at/',
      'https://www.pinterest.de/drsmile_de/',
      'https://www.youtube.com/channel/UCrK0aMXoPfRKE1twYHPB36w',
      'https://www.linkedin.com/company/drsmile/',
      'https://www.xing.com/companies/drsmile',
      'https://www.tiktok.com/@drsmile_official',
      'https://www.kununu.com/de/drsmile',
    ],
  },

  'pt-PT': {
    descriptionOrg:
      'DR SMILE é o líder em alinhamento dentário especializado em Tratamentos de Ortodontia Invisível de alta qualidade, personalizados, e supervisionados por dentistas.',
    contactPoint: {
      telephone: '+351308800355',
      email: 'patient@dr-smile.pt',
    },
    address: {
      addressCountry: 'PT',
    },
    sameAs: [
      '',
      'https://www.facebook.com/p/DR-SMILE-Portugal-100077590446548/',
      'https://www.instagram.com/drsmile.pt/',
      'https://www.pinterest.de/drsmile_de/',
      'https://www.youtube.com/channel/UCrK0aMXoPfRKE1twYHPB36w',
      'https://www.linkedin.com/company/drsmile/',
      'https://www.xing.com/companies/drsmile',
      'https://www.tiktok.com/@drsmile_official',
    ],
  },

  es: {
    descriptionOrg:
      'DR SMILE es especializado en Tratamientos de Ortodoncia Invisible de alta calidad, hechos a medida y supervisados por dentistas. Libera tu potencial y sonríe con confianza.',
    contactPoint: {
      telephone: '+34932712030',
      email: 'paciente@drsmile.es',
    },
    address: {
      addressCountry: 'ES',
    },
    sameAs: [
      '',
      'https://www.facebook.com/drsmile.es/',
      'https://www.instagram.com/drsmile.es/',
      'https://www.pinterest.de/drsmile_de/',
      'https://www.youtube.com/channel/UCrK0aMXoPfRKE1twYHPB36w',
      'https://www.linkedin.com/company/drsmile/',
      'https://www.xing.com/companies/drsmile',
      'https://www.tiktok.com/@drsmile_official',
    ],
  },
  fr: {
    descriptionOrg:
      "DR SMILE est spécialisé dans l'alignement dentaire invisible, utilisant des technologies avancées et personnalisées sous la supervision d'un chirurgien-dentiste. Libérez votre potentiel et souriez en toute confiance.",
    contactPoint: {
      telephone: '+33 176430117',
      email: 'pacient@drsmile-group.com',
    },
    address: {
      addressCountry: 'FR',
    },
    sameAs: [
      '',
      'https://www.facebook.com/drsmile.fr/',
      'https://www.instagram.com/drsmile.fr/',
      'https://www.pinterest.de/drsmile_de/',
      'https://www.youtube.com/channel/UCrK0aMXoPfRKE1twYHPB36w',
      'https://www.linkedin.com/company/drsmile/',
      'https://www.xing.com/companies/drsmile',
      'https://www.tiktok.com/@drsmile_official',
    ],
  },
  it: {
    descriptionOrg:
      'DR SMILE: allineatori trasparenti per allineare i tuoi denti con efficienza, rapidità e comfort. Miglioriamo la fiducia di un sorriso con una soluzione innovativa e professionale.',
    contactPoint: {
      telephone: '+390694801010',
      email: 'patient@dr-smile.it',
    },
    address: {
      addressCountry: 'IT',
    },
    sameAs: [
      '',
      'https://www.facebook.com/DrSmile.it/',
      'https://www.instagram.com/drsmile.it/',
      'https://www.pinterest.de/drsmile_de/',
      'https://www.youtube.com/channel/UCrK0aMXoPfRKE1twYHPB36w',
      'https://www.linkedin.com/company/drsmile/',
      'https://www.xing.com/companies/drsmile',
      'https://www.tiktok.com/@drsmile_official',
    ],
  },
  se: {
    descriptionOrg:
      'DR SMILE är experter inom tandreglering och erbjuder skräddarsydda lösningar till överkomliga priser. Leenden är vår passion och specialitet.',
    contactPoint: {
      telephone: '+46 31 301 18 55',
      email: 'patient@drsmile.se',
    },
    address: {
      addressCountry: 'SE',
    },
    sameAs: [
      '',
      'https://www.facebook.com/people/DR-SMILE-Sverige/100065315446959/',
      'https://www.instagram.com/drsmile.se/',
      'https://www.pinterest.de/drsmile_de/',
      'https://www.youtube.com/channel/UCrK0aMXoPfRKE1twYHPB36w',
      'https://www.linkedin.com/company/drsmile/',
      'https://www.xing.com/companies/drsmile',
      'https://www.tiktok.com/@drsmile_official',
    ],
  },
  nl: {
    descriptionOrg:
      'DR SMILE is expert op het gebied van het rechtzetten van tanden middels op maat gemaakte alignerbehandelingen die begeleid worden door tandartsen. Boost je zelfvertrouwen met een nieuwe glimlach.',
    contactPoint: {
      telephone: '+31 70 808 0333',
      email: 'customer@drsmile.nl',
    },
    address: {
      addressCountry: 'NL',
    },
    sameAs: [
      '',
      'https://www.facebook.com/p/DR-SMILE-Nederland-100065450471323/',
      'https://www.instagram.com/drsmile.nl/',
      'https://www.pinterest.de/drsmile_de/',
      'https://www.youtube.com/channel/UCrK0aMXoPfRKE1twYHPB36w',
      'https://www.linkedin.com/company/drsmile/',
      'https://www.xing.com/companies/drsmile',
      'https://www.tiktok.com/@drsmile_official',
    ],
  },
  pl: {
    descriptionOrg:
      'DR SMILE gilt als Expert*in für Zahnkorrekturen mit spezialisierten und individuellen Lösungen zu fairen Preisen. Wir ermöglichen selbstbewusste Lächeln durch unsere maßgeschneiderten Zahnschienen und personalisierte Betreuung.',
    contactPoint: {
      telephone: '+49 30 22957384',
      email: 'customer@drsmile.de',
    },
    address: {
      addressCountry: 'PL',
    },
    sameAs: [
      '',
      'https://www.facebook.com/drsmile.de/',
      'https://www.instagram.com/drsmile.de/',
      'https://www.pinterest.de/drsmile_de/',
      'https://www.youtube.com/channel/UCrK0aMXoPfRKE1twYHPB36w',
      'https://www.linkedin.com/company/drsmile/',
      'https://www.xing.com/companies/drsmile',
      'https://www.kununu.com/de/drsmile',
    ],
  },
  'de-CH': {
    descriptionOrg:
      'DR SMILE gilt als Expert*in für Zahnkorrekturen mit spezialisierten und individuellen Lösungen zu fairen Preisen. Wir ermöglichen selbstbewusste Lächeln durch unsere maßgeschneiderten Zahnschienen und personalisierte Betreuung.',
    contactPoint: {
      telephone: '+493022957384',
      email: 'customer@drsmile.de',
    },
    address: {
      addressCountry: 'CH',
    },
    sameAs: [
      '',
      'https://www.facebook.com/drsmile.de/',
      'https://www.instagram.com/drsmile.de/',
      'https://www.pinterest.de/drsmile_de/',
      'https://www.youtube.com/channel/UCrK0aMXoPfRKE1twYHPB36w',
      'https://www.linkedin.com/company/drsmile/',
      'https://www.xing.com/companies/drsmile',
      'https://www.kununu.com/de/drsmile',
    ],
  },
  'en-GB': {
    descriptionOrg:
      'DR SMILE gilt als Expert*in für Zahnkorrekturen mit spezialisierten und individuellen Lösungen zu fairen Preisen. Wir ermöglichen selbstbewusste Lächeln durch unsere maßgeschneiderten Zahnschienen und personalisierte Betreuung.',
    contactPoint: {
      telephone: '+49 30 22957384',
      email: 'customer@drsmile.de',
    },
    address: {
      addressCountry: 'GB',
    },
    sameAs: [
      '',
      'https://www.facebook.com/drsmile.de/',
      'https://www.instagram.com/drsmile.de/',
      'https://www.pinterest.de/drsmile_de/',
      'https://www.youtube.com/channel/UCrK0aMXoPfRKE1twYHPB36w',
      'https://www.linkedin.com/company/drsmile/',
      'https://www.xing.com/companies/drsmile',
      'https://www.kununu.com/de/drsmile',
    ],
  },
};

module.exports = translationsLocationTimes;
